import { compose } from 'recompose'
import { connect } from 'react-redux'

import fetchesPublicNote from './dataSync/fetchesPublicNote'
import { getPublicNoteByToken } from 'data/publicNotes/selectors'
import { listJoinedOrganizations } from 'helpers/OrganizationsHelpers'
import {
  getOrganization,
  getOrganizationId,
} from 'data/organizations/selectors'

export default compose(
  fetchesPublicNote(),
  connect(function mapStateToProps(state, { token }) {
    const joinedOrganizationIds = listJoinedOrganizations()
    const organizationId = getOrganizationId(state)
    const organization = getOrganization(state)

    const note = getPublicNoteByToken(state, token)

    const alreadyJoined = joinedOrganizationIds.includes(organizationId)
    const alreadyUser = joinedOrganizationIds.length > 0

    return {
      organization,
      alreadyJoined,
      alreadyUser,
      note,
    }
  })
)
